import React from 'react';

import { Directory } from 'components';

import { S } from './Home.style';

export const HomePage: React.FC = () => (
  <S.Wrapper>
    <Directory />
  </S.Wrapper>
);
